
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/fabrica-navidul",
      function () {
        return require("private-next-pages/es/fabrica-navidul/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/fabrica-navidul"])
      });
    }
  